// Look-back window (in days) for the Vehicle State of Charge Summary card. The numeric value is the
// number of days the table spans and is also what gets persisted to local storage.
export enum VehicleSocSummaryRange {
  Last7Days = 7,
  Last14Days = 14,
}

export const DEFAULT_VEHICLE_SOC_SUMMARY_RANGE = VehicleSocSummaryRange.Last7Days;
